import * as React from 'react'

export function ServiceTypeCell({ row }) {
  const feedback = row.original

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="text-normal line-clamp-1 font-bold">
        {feedback.display_name}
      </div>
    </div>
  )
}
